import { NavLink } from "react-router-dom";
import './Header.css';
import { isPwa } from '/src/utils/isPwa';
import { useAuthStateContext } from "/src/features/auth/context/authContext";
import Storage from "/src/utils/storage";
function Header() {
    //const { user } = useAuthStateContext();
    //const storage = Storage('local').get("user");
    //const storage = Storage('session').get('company');
    //var logo = storage?.logo;

    return (
        <div className="header">
            <div className="logo-anytech" />
        </div>
    )
}

export default Header;
